import { baseUrl, gtmEventName } from '@/data/appConfig'

const logger = require('debug')('careship:gtm')

declare global {
  interface Window {
    dataLayer: Array<Object | string | number>
  }
}

type TagManagerViewEvent = {
  event: string
  'page-name': string
  appPagePath?: string
}

type TagManagerAppEvent = {
  event: string
  category?: string
  action?: string
  label?: string
  value?: string
  'non-interaction': number
}

type AppEvent = {
  category?: string
  action?: string
  label?: string
  value?: string
  interactive?: boolean
}

export default class TagManager {
  private readonly eventName: string

  constructor() {
    this.eventName = gtmEventName
  }

  static getDataLayer() {
    return window.dataLayer || []
  }

  // Motivation for disable-next-line: ESLint doesn't pick up that this is used by instances of TagManager
  // eslint-disable-next-line class-methods-use-this
  push(gtmEvent: TagManagerViewEvent | TagManagerAppEvent) {
    TagManager.getDataLayer().push(gtmEvent)
  }

  trackView(pageName: string, path?: string) {
    logger('analytics/gtm -> trackView %s', pageName)

    const pathWithoutHash = path.replace(/#.*/g, '')

    const viewEvent: TagManagerViewEvent = {
      event: 'history-update',
      'page-name': pageName,
      appPagePath: `${baseUrl}${pathWithoutHash}`,
    }

    this.push(viewEvent)
  }

  trackEvent(params: AppEvent) {
    const { category, action, label, value, interactive } = params

    logger('analytics/gtm -> trackEvent %s -> %O', action, {
      category,
      action,
      label,
      value,
      interactive,
    })

    this.push({
      event: this.eventName,
      category: String(category || '').toLowerCase(),
      action: String(action || '').toLowerCase(),
      label: String(label || '').toLowerCase(),
      value: String(value || '').toLowerCase(),
      'non-interaction': interactive ? 0 : 1,
    })
  }
}
